import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { SelectRadioGroup } from "@circle-react-shared/uikit/SelectRadioGroup";
import { SCREEN_SIZES } from "./constants";
import { isScreenSize } from "./utils";

const defaultOptions = [
  {
    value: SCREEN_SIZES.DESKTOP,
    label: <Icon type="20-desktop-v2" size={20} aria-label={t("desktop")} />,
    tooltipText: t("desktop"),
  },
  {
    value: SCREEN_SIZES.TABLET,
    label: <Icon type="20-tablet-v2" size={20} aria-label={t("tablet")} />,
    tooltipText: t("tablet"),
  },
  {
    value: SCREEN_SIZES.MOBILE,
    label: <Icon type="20-mobile-v2" size={20} aria-label={t("mobile")} />,
    tooltipText: t("mobile"),
  },
];

export type ScreenSize = (typeof SCREEN_SIZES)[keyof typeof SCREEN_SIZES];

export interface ScreenSizeRadioGroupProps {
  onChange: (value: ScreenSize) => void;
  options?: typeof defaultOptions;
  selected: ScreenSize;
}

export const ScreenSizeRadioGroup = ({
  selected,
  onChange,
  options = defaultOptions,
}: ScreenSizeRadioGroupProps) => {
  const onChangeHandler = (value: string) => {
    if (!isScreenSize(value)) {
      return;
    }
    onChange(value);
  };

  return (
    <SelectRadioGroup
      value={selected}
      options={options}
      onChange={onChangeHandler}
      size="sm"
      className="gap-1"
    />
  );
};
